import { ChangeDetectionStrategy, Component, computed, input, signal } from '@angular/core';

import { ModalButtons } from '@fcom/ui-components';
import { BoundType } from '@fcom/dapi';
import { FinnairBoundItem, FinnairCabinClass, FinnairItineraryItemFlight, FinnairOrder } from '@fcom/dapi/api/models';
import { getTails, isByBusOnly } from '@fcom/common-booking/utils/common-booking.utils';

@Component({
  selector: 'fin-booking-flight',
  templateUrl: './flight.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class BookingFlightComponent {
  readonly ModalButtons = ModalButtons;
  readonly BoundType = BoundType;

  modalOpen = signal(false);

  /**
   * Flight Bound Information
   */
  bound = input<FinnairBoundItem>();

  /**
   * A map of the locations in the bound/booking to get city and airport names
   */
  locations = input<FinnairOrder['locations']>();

  /**
   * Type of bound to render in the timeline
   */
  type = input<BoundType>(null);

  isBookingFlow = input(false);

  tails = computed(() => getTails(this.bound()));
  isByBusOnly = computed(() => isByBusOnly(this.bound()));
  cabin = computed(() => this.getCabinClass(this.bound()));

  openViewDetails(): void {
    this.modalOpen.set(true);
  }

  getCabinClass(bound: FinnairBoundItem): FinnairCabinClass {
    return bound.cabinClass ?? (bound.itinerary[0] as FinnairItineraryItemFlight).cabinClass;
  }
}
